<script>
  /* Executable code section of the program */
  //Tools importation
  import { onMount, afterUpdate } from "svelte";
  import { db, ref, push, onChildAdded } from "../../apis/apisChat";
  import {
    getOneDocument,
    getSpecificDocuments,
    updateMultipleDocuments,
  } from "../../apis/APIS";
  import {
    temporalChatAttendee,
    chatId,
    userRealTime,
    confirmationResponse,
    isOpenChat,
    userLocalData,
    chatsActive,
    dinamicChat,
    isChatModalOn,
  } from "../../apis/storage";
  import { sendInvitationEmail,sendEventNotification  } from "../../apis/apisSendEmail";

  //auxiliary variables
  let texts = [];
  let postArray = [];
  let messagge = "";
  let localUser = {};
  $: dinamicText = [];
  let chatRef;
  let unsubscribe;
  let isChatLogged = false;
  let windowSize = window.innerWidth;
  let messagesContainer;
  let chatLink1;
  let chatLink2;
  let condition1;
  let condition2;
  let unreadCount = 0;

  //Function to verify the chatId
  const isValueInArray = (chats, key, value) => {
    return chats.some((obj) => obj[key] === value);
  };
  afterUpdate(() => {
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  });

  /* 
  const chatRef = ref(db, `chats/adios`); // Database reference */
  const getChatByLink = (link) => {
    if (unsubscribe) unsubscribe(); // Detach the previous listener if it exists

    chatRef = ref(db, link); // Reference to the database

    unsubscribe = onChildAdded(chatRef, (snapshot) => {
      if (snapshot.exists()) {
        texts.push(snapshot.val()); // Add only the new message
        dinamicText = texts; // Copy the updated array
        /* Funcines para los mensajes leidos */

      }
      //functio to add chat to the attendees

      if (texts.length > 0 && texts.length <= 1 && !condition1 && !condition2) {
        //Saving chat to the database
        //Stored in the active user
        postArray.push({
          id: localUser.id,
          fieldName: "myChats",
          values: [
            {
              id: $temporalChatAttendee.id,
              name: $temporalChatAttendee.name,
              surname: $temporalChatAttendee.surname,
              jobtittle: $temporalChatAttendee.jobtittle,
              company: $temporalChatAttendee.company,
              country: $temporalChatAttendee.country,
              profileImgUrl: $temporalChatAttendee.profileImgUrl,
              chatId: $chatId,
              eventTittle: localUser.event,
              email: $temporalChatAttendee.email,
            },
          ],
        });
        //Stored in the guest user
        postArray.push({
          id: $temporalChatAttendee.id,
          fieldName: "myChats",
          values: [
            {
              id: localUser.id,
              name: localUser.name,
              surname: localUser.surname,
              jobtittle: localUser.jobtittle,
              company: localUser.company,
              country: localUser.country,
              profileImgUrl: localUser.profileImgUrl,
              chatId: $chatId,
              eventTittle: localUser.event,
              email: localUser.email,
            },
          ],
        });

        //Function to update data
        postArray.length > 0 && updateMultipleDocuments("users", postArray);
      }
    });
  };

  //section to keep messagges container update
  const scrollToBottom = () => {
    const container = document.getElementsByClassName("messages");
    container.scrollTop = container.scrollHeight;
  };

  //Function to show text time
  const getFormattedDate = (date) => {
    const now = new Date(date);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  // Function to send messagge
  const sendMessagge = () => {
    let messageKey = `lastMessage-${$chatId}`
    if (messagge.trim() !== "") {
      const lastMessage = texts[texts.length - 1];
      if (localUser.userRole !== "attendee") {
      push(chatRef, {
        text: messagge,
        timestamp: Date.now(),
        user: {
          name: "Coordinator",
          surname: "",
        },
      });
      } else {
      push(chatRef, {
        text: messagge,
        timestamp: Date.now(),
        user: {
          name: $dinamicChat ? localUser.name : "Coordinator",
          surname: $dinamicChat ? localUser.surname : "",
        },
      });
      }

      if (localUser.userRole === "attendee") {
      if (lastMessage?.user?.name !== localUser.name) {
        sendInvitationEmail(
          $temporalChatAttendee.email,
          "chat",
          $temporalChatAttendee,
          localUser,
          window.location.pathname.split("/")[2]
        );
      }
      } else {
        
        sendAll(messagge)
      }
      localStorage.setItem(messageKey,Date.now())
      
      scrollToBottom();
      messagge = "";
    }
  };

  //Function to send All attendees mail
  const sendAll = async() =>{
    let chatIdentificator = $chatId.split("-")
    let users = []

    if (!chatIdentificator.includes(localUser.id)) {
      users = await getSpecificDocuments("users","event",chatIdentificator[0])
      users.forEach(element =>{
        sendEventNotification(element.email,messagge,element)
      })
    }
  }

  //Function to manage meet status.
  const manageMeet = () => {
    //Section to notify meet rejection or acceptance.
    let confirmMessagge = "";

    if ($confirmationResponse === "Accept") {
      confirmMessagge = `${localUser.name} ${localUser.surname} has accepted to meet in the meeting card.`;
      setTimeout(() => {
        push(chatRef, {
          text: confirmMessagge,
          timestamp: Date.now(),
          user: {
            name: localUser.name,
            surname: localUser.surname,
          },
        });
      }, 500);
    } else {
      confirmMessagge = `${localUser.name} ${localUser.surname} has declined to meet in the meeting card.`;
      setTimeout(() => {
        push(chatRef, {
          text: confirmMessagge,
          timestamp: Date.now(),
          user: {
            name: localUser.name,
            surname: localUser.surname,
          },
        });
      }, 500);
    }
  };
  //Function to undisplay chat
  const undisplayChat = () => {
    $isOpenChat = false;
    $isChatModalOn = false;
  };

  //Initial functions
  onMount(async () => {
    localUser = $userLocalData[0]

    /* Funcion para verificar la existencia de un chat previo */
    chatLink1 = `${$temporalChatAttendee.id}-${localUser.id}`;
    chatLink2 = `${localUser.id}-${$temporalChatAttendee.id}`;
    condition1 = isValueInArray(localUser.myChats, "chatId", chatLink1);
    condition2 = isValueInArray(localUser.myChats, "chatId", chatLink2);

    if ($temporalChatAttendee?.hasOwnProperty("chatId")) {
      $chatId = $temporalChatAttendee.chatId
        ? $temporalChatAttendee.chatId
        : `${$temporalChatAttendee.id}-${localUser.id}`;
    } else if (condition1 || condition2) {
      $chatId = condition1 ? chatLink1 : chatLink2;
    } else {
      $chatId = `${$temporalChatAttendee.id}-${localUser.id}`;
    }

    getChatByLink(`chats/${$chatId}`);
    if ($confirmationResponse !== "") {
      manageMeet();
    }
    setTimeout(() => {
      isChatLogged = true;
    }, 330);
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $temporalChatAttendee.hasOwnProperty("name")}
  <!-- Section to display chat for One to One Chat -->
  <div class="chat-container">
    <div class="headerContent">
      <div class="avatarContainer"></div>
      <div class="infoContainer">
        <h5>{$temporalChatAttendee.name} {$temporalChatAttendee.surname}</h5>
        <p>
          {$temporalChatAttendee.jobtittle}<br />
          {$temporalChatAttendee.company}
        </p>
      </div>
    </div>
    <div class="messages">
      {#if isChatLogged}
        {#if dinamicText.length > 0}
          {#each dinamicText as msg}
            <div class="messageContainer">
              <div class="tittleContainer">
                <p class="nameText">
                  <b>{msg.user.name} {msg.user.surname}</b>
                </p>
                <p class="timeText">{getFormattedDate(msg.timestamp)}</p>
              </div>
              <div class="textContainer"></div>
              <p class="text">{msg.text}</p>
            </div>
          {/each}
        {:else}
          <div class="emptyMessageContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              class="bi bi-chat-square-dots"
              viewBox="0 0 16 16"
            >
              <path
                d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
              />
              <path
                d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
              />
            </svg>
            <p class="emptyText">
              You have no previous messages with {$temporalChatAttendee.name}
              {$temporalChatAttendee.surname}. Greet them.
            </p>
          </div>
        {/if}
      {/if}
    </div>
    <div class="footerContent">
      {#if $chatsActive || $userLocalData[0].userRole !== "attendee"}
        <div class="form-floating">
          <textarea
            class="form-control"
            placeholder="Leave a comment here"
            id="floatingTextarea2"
            style="height: 100px"
            bind:value={messagge}
          ></textarea>
          <label for="floatingTextarea2">Type a message...</label>
        </div>
      {/if}
      <div class="buttonsContainer">
        {#if windowSize <= 700}
          <button class="actionBtn" on:click={undisplayChat}>Back</button>
        {/if}

        <button class="actionBtn addEventBtn" on:click={sendMessagge}
          >Send</button
        >
      </div>
    </div>
  </div>
  <!-- Section to display chat for One to All Chat -->
{:else}
  <div class="chat-container">
    <div class="headerContent">
      <div class="avatarContainer"></div>
      <div class="infoContainer">
        <h5>{$temporalChatAttendee.eventTittle}</h5>
      </div>
    </div>
    <div class="messages" bind:this={messagesContainer}>
      {#if isChatLogged}
        {#if dinamicText.length > 0}
          {#each dinamicText as msg}
            <div class="messageContainer">
              <div class="tittleContainer">
                <p class="nameText">
                  <b>{msg.user.name} {msg.user.surname}</b>
                </p>
                <p class="timeText">{getFormattedDate(msg.timestamp)}</p>
              </div>
              <div class="textContainer"></div>
              <p class="text">{msg.text}</p>
            </div>
          {/each}
        {:else}
          <div class="emptyMessageContainer">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              fill="currentColor"
              class="bi bi-chat-square-dots"
              viewBox="0 0 16 16"
            >
              <path
                d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
              />
              <path
                d="M5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
              />
            </svg>
            <p class="emptyText">No announcements have been published yet</p>
          </div>
        {/if}
      {/if}
    </div>
    {#if $userLocalData[0].userRole !== "attendee"}
      <div class="footerContent">
        <div class="form-floating">
          <textarea
            class="form-control"
            placeholder="Leave a comment here"
            id="floatingTextarea2"
            style="height: 100px"
            bind:value={messagge}
          ></textarea>
          <label for="floatingTextarea2">Type a message...</label>
        </div>
        <div class="buttonsContainer">
          {#if windowSize <= 700}
            <button class="actionBtn" on:click={undisplayChat}>Back</button>
          {/if}
          <button class="actionBtn addEventBtn" on:click={sendMessagge}
            >Send</button
          >
        </div>
      </div>
    {/if}
  </div>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .chat-container {
    width: 100%;
    height: 90%;
  }
  /* Content styles */
  /* Header chat styles */
  .headerContent {
    padding: 10px;
    width: 100%;
    height: auto;
    border-bottom: 1px solid gray;
  }
  .infoContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  /* Body chat styles*/
  .messages {
    height: 55%;
    overflow: auto;
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f4f4f4;
    border-bottom: 1px solid gray;
    margin: 5px 0;
  }
  /* Empty styles */
  .emptyMessageContainer {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .emptyText {
    width: 50%;
    text-align: center;
  }
  /* Content Styles */
  .messageContainer {
    width: 100%;
    height: auto;
    padding: 5px;
  }
  .tittleContainer {
    display: flex;
    line-height: 0.8;
  }
  .nameText {
    width: auto;
    margin-right: 5px;
    line-height: 0.2;
  }
  .timeText {
    width: 20%;
    margin-left: 5px;
    font-size: 12px;
    color: gray;
    line-height: 0.2;
  }
  /* Footer chat styles */
  .footerContent {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    align-items: flex-end;
  }
  .form-floating {
    width: 100%;
  }
  .form-control {
    resize: none;
  }
  .actionBtn {
    width: 150px;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 10px 5px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .buttonsContainer {
    display: flex;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .actionBtn {
      background-color: #ed2824;
      color: white;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    /* Body chat styles*/
    .messages {
      height: 250px;
      overflow: auto;
      border: 1px solid #ccc;
      padding: 10px;
      background-color: #f4f4f4;
      border-bottom: 1px solid gray;
      margin: 5px 0;
    }
    /* Send button */
    .actionBtn {
      background-color: #ed2824;
      color: white;
    }
  }

  /* End of the section */
</style>
